import { render, staticRenderFns } from "./w-router-view.vue?vue&type=template&id=e46c7d5e&"
import script from "./w-router-view.vue?vue&type=script&lang=js&"
export * from "./w-router-view.vue?vue&type=script&lang=js&"
import style0 from "./w-router-view.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports